import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { analysisApi } from '../api/analysis.api';
import { useParams } from 'react-router-dom';

export const useAnalysisActions = () => {
  const queryClient = useQueryClient();
  const { id } = useParams();

  const invalidateFile = (id: string) => {
    queryClient.invalidateQueries({ queryKey: ['resultData', id] });
    queryClient.invalidateQueries({ queryKey: ['downloadData', id] });
    queryClient.invalidateQueries({ queryKey: ['fontData', id] });
    queryClient.invalidateQueries({ queryKey: ['mrzData', id] });
    queryClient.invalidateQueries({ queryKey: ['notesData', id] });
    queryClient.invalidateQueries({ queryKey: ['compareData', id] });
  };

  const checkMRZMutation = useMutation({
    mutationFn: analysisApi.checkMRZ,
    onSuccess: (data) => {
      if (id) {
        invalidateFile(id);
      }
      return data;
    },
    onError: () => {
      toast.error('Une erreur est survenue');
    },
  });

  const reportBugMutation = useMutation({
    mutationFn: (message: string) => analysisApi.reportBug(id || '', message),
    onSuccess: () => {
      toast.success('Message envoyé au support.');
    },
    onError: () => {
      toast.error(
        "Erreur lors de l'envoie du message, contactez le support ou réessayez plus tard."
      );
    },
  });

  const checkMRZ = async (mrz: string[]) => {
    return await checkMRZMutation.mutateAsync(mrz);
  };

  const reportBug = async (message: string) => {
    return await reportBugMutation.mutateAsync(message);
  };

  return {
    checkMRZ,
    reportBug,
    isLoading: checkMRZMutation.isPending || reportBugMutation.isPending,
  };
};
